module.exports = __webpack_public_path__ + "img/id.12fe44a3.png";